import { Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
export var LineItemPricing = function (_a) {
    var _b, _c;
    var _d = _a.otherDiscountAmount, otherDiscountAmount = _d === void 0 ? 0 : _d, _e = _a.quantity, quantity = _e === void 0 ? 1 : _e, netUnitPrice = _a.netUnitPrice, unitPrice = _a.unitPrice, _f = _a.originalUnitPrice, originalUnitPrice = _f === void 0 ? 0 : _f, statusDescription = _a.statusDescription;
    var itemUnitPrice = (_b = (unitPrice === undefined ? netUnitPrice : unitPrice)) !== null && _b !== void 0 ? _b : 0;
    if (statusDescription === 'Canceled') {
        return (React.createElement("div", { className: "sui-flex sui-flex-col sui-mt-2" }, Boolean(itemUnitPrice) && (React.createElement(Typography, { weight: "bold" },
            "$", itemUnitPrice === null || itemUnitPrice === void 0 ? void 0 :
            itemUnitPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })))));
    }
    if (quantity === 1) {
        return (React.createElement("div", { className: "sui-flex sui-flex-col sui-mt-2" },
            itemUnitPrice ? (React.createElement(Typography, { weight: "bold" },
                "$", itemUnitPrice === null || itemUnitPrice === void 0 ? void 0 :
                itemUnitPrice.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }))) : null,
            otherDiscountAmount === 0 ? null : (React.createElement(React.Fragment, null,
                originalUnitPrice && (React.createElement(Typography, { decoration: "line-through" },
                    "$", originalUnitPrice === null || originalUnitPrice === void 0 ? void 0 :
                    originalUnitPrice.toLocaleString('en-US', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }))),
                itemUnitPrice && originalUnitPrice && (React.createElement(Typography, { color: "success" },
                    "Save",
                    ' ',
                    (((originalUnitPrice - itemUnitPrice) / originalUnitPrice) *
                        100).toFixed(0),
                    "%"))))));
    }
    if (quantity > 1) {
        return (React.createElement("div", { className: "sui-mt-2" },
            React.createElement(Typography, { weight: "bold" },
                "$", (_c = (quantity * itemUnitPrice)) === null || _c === void 0 ? void 0 :
                _c.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                })),
            otherDiscountAmount === 0 ? (React.createElement(Typography, null,
                "($", itemUnitPrice === null || itemUnitPrice === void 0 ? void 0 :
                itemUnitPrice.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }),
                "/item)")) : (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-flex" },
                    "(",
                    React.createElement(Typography, null,
                        "$", itemUnitPrice === null || itemUnitPrice === void 0 ? void 0 :
                        itemUnitPrice.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }),
                        "/item"),
                    React.createElement("div", { className: "sui-w-1" }),
                    React.createElement(Typography, { decoration: "line-through" },
                        "$", originalUnitPrice === null || originalUnitPrice === void 0 ? void 0 :
                        originalUnitPrice.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })),
                    ")"),
                itemUnitPrice && originalUnitPrice && (React.createElement(Typography, { color: "success" },
                    "Save",
                    ' ',
                    (((originalUnitPrice - itemUnitPrice) / originalUnitPrice) *
                        100).toFixed(0),
                    "%"))))));
    }
    return null;
};
